'use strict';
module.exports = require('./DataViewLayoutOptions.vue');